var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgRecordedContent = function SvgRecordedContent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "recordedContent_svg__a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#126bd5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#439aff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5559"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 1240",
    d: "M0 0h30v30H0z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 5463"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2507"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2516"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 25",
    d: "M19 23H2a2 2 0 01-2-2V2a2 2 0 012-2h17a2 2 0 012 2v19a2 2 0 01-2 2zM6.706 8.44a.5.5 0 00-.5.5v5.765a.5.5 0 00.744.436l5.157-2.883a.5.5 0 000-.873L6.949 8.5a.493.493 0 00-.243-.06z",
    transform: "translate(6 4)",
    fill: "url(#recordedContent_svg__a)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 2506"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 734",
    transform: "translate(3 4)",
    stroke: "#000",
    fill: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 22,
    rx: 3.5
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 148",
    transform: "translate(18 15)",
    stroke: "#fff",
    fill: "url(#recordedContent_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 589",
    d: "M23.514 18.184v2.75h2.229",
    strokeLinecap: "round",
    stroke: "#fff",
    fill: "none"
  }))))))));
};
export default SvgRecordedContent;